/*eslint-disable multiline-ternary */
/*eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Row,
  Card,
  Col,
  OverlayTrigger,
  Popover,
  Modal,
  Container,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { formatDoctorName } from '../../../../utils/common';
import { t } from 'i18next';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import CheckboxInput from '../../../../components/common/Checkbox';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import ProgressBar from 'src/Member/components/progressbar/progressbar';
import SearchCoveredCard from '../../skeleton/SearchCoveredCard';
import { ConfigurationSVG } from '../../../../../Admin/img/GlobalSVG';
import {
  ErrorCircle,
  ProviderBoardCertificateImage,
  ProviderEducationImage,
  ProviderImageWomen,
  ProviderImageMen,
  SuccessCircle,
  FacilityIcon,
  ProviderDetailedGenderUnknown,
  ProviderImageUnknownGender,
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../../img/findcare/FindCareSVG';
import {
  setShowCostClickTimestamp,
  setShowCostClickCount,
  resetShowCostClickCount,
} from 'src/redux/admin/priceCompareSlice';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from 'src/Admin/components/common/ToastMessage';
import { PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD } from 'src/constants';

const AcceptingNewPatientsChip = ({ variant }) => {
  return (
    <span className={`accept-new-patient-${variant} d-block`}>
      <div className="d-flex align-items-center">
        {variant === 'success' && <SuccessCircle className="success-circle" />}
        {variant === 'danger' && <ErrorCircle className="danger-circle" />}
        <span>{t('find_provider.accepting_new_patients')}</span>
      </div>
    </span>
  );
};

const InNetworkChip = ({ variant }) => {
  return (
    <span className={`in-network-${variant} d-block mt-2`}>
      <div className="d-flex align-items-center">
        {variant === 'success' && <SuccessCircle className="success-circle" />}
        {variant === 'danger' && <ErrorCircle className="danger-circle" />}
        <span>
          {variant === 'success'
            ? t('find_provider.in_network')
            : t('find_provider.out_of_network')}
        </span>
      </div>
    </span>
  );
};
function findPercentage(min, max) {
  let defaultPercentage = 0;
  if (min > 0) {
    defaultPercentage = (min * 100) / max;
  }
  if (defaultPercentage > 100) {
    defaultPercentage = 100;
  }
  return defaultPercentage;
}
const ResultCard = ({
  data,
  elemkey,
  isAccordion = false,
  setSelectedCheckedItems,
  selectedCheckedItems,
  setSelectedCheckedRowData,
  selectedCheckedRowData,
  serachNetworksFor,
  CoveredCostComparePriceArray,
}) => {
  const showCostBtnRef = useRef(0);

  const [checked, setChecked] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isActiveCost, setIsActiveCost] = useState(false);
  const [coveredCostData, setCoveredCostData] = useState();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [isOpenDisclaimerPopup, setisOpenDisclaimerPopup] = useState(false);
  const dispatch = useDispatch();
  const {
    //searchProviderParams: { Network },
    address,
    networksList,
    networkTierList,
    searchParamsForUI,
    providerType,
    searchProviderParams,
    showCostClickTimestamp,
    showCostClickCount,
    showCostClickTimeThreshold = PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
    showCostClickNumThreshold = PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.clicks,
  } = useSelector(({ priceCompareAdmin }) => priceCompareAdmin);
  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams.filters,
  );

  const { Provider } = allFilters;
  const addressZip = useSelector(
    (state) => state?.priceCompareAdmin?.searchParamsForUI?.locationData,
  );
  const {
    Value_Network_For_PriceComparison_Admin,
    Display_Network_For_PriceComparison_Admin,
    Display_Network_Indicator_for_Price_Comparison_page,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const noDataMessage = t('find_provider.data_not_available');
  const inNetworkList = [];

  if (Value_Network_For_PriceComparison_Admin === 'network') {
    if (data?.InNetwork === true && data?.DoctorNetworks?.length > 0) {
      data?.DoctorNetworks.forEach((eachNetwork) => {
        if (
          networkTierList.findIndex((ele) => ele.value === eachNetwork) !== -1
        ) {
          inNetworkList.push(eachNetwork);
        }
      });
    }
  }

  let uniqueTier = [];
  if (Value_Network_For_PriceComparison_Admin === 'tier') {
    const tierArr = [];
    if (data.DoctorNetworks?.length > 0) {
      networkTierList.forEach((eachNetwork) => {
        if (
          data.DoctorNetworks.findIndex(
            (ele) => ele === eachNetwork.NetworkDescription,
          ) !== -1
        ) {
          tierArr.push(eachNetwork.NetworkTier);
        }
      });
      uniqueTier = [...new Set(tierArr)];
      uniqueTier.sort();
    }
  }

  const onSelectRowHandler = (e, data, ConnectorId) => {
    setChecked(e.target.checked);
    if (e.target.checked) {
      dispatch(setSelectedCheckedItems([...selectedCheckedItems, ConnectorId]));
      dispatch(setSelectedCheckedRowData([...selectedCheckedRowData, data]));
    } else {
      dispatch(
        setSelectedCheckedItems(
          selectedCheckedItems.filter((id) => id !== ConnectorId),
        ),
      );
      dispatch(
        setSelectedCheckedRowData(
          selectedCheckedRowData.filter(
            (item) => item.ConnectorId !== ConnectorId,
          ),
        ),
      );
    }
  };

  const onToggleClickHandler = () => {
    setIsActive(!isActive);
  };
  function apiDataGenerationForCompare({ searchParamsForUI }) {
    const DATA = [];
    let billedAmountVal;

    if (searchParamsForUI?.billedamount === '') {
      billedAmountVal = Number(searchParamsForUI?.billedamount);
    } else {
      billedAmountVal = searchParamsForUI?.billedamount;
    }
    const obj = {
      MemberType:
        searchParamsForUI?.procedureForData.memberType === 'Member'
          ? 'Employee'
          : 'Dependent',
      SelEmployeeMemberOID: searchParamsForUI?.procedureForData.value,
      Serviceprovider: data.ConnectorId,
      BilledAmt: billedAmountVal,
    };
    if (searchParamsForUI?.helthProcedureData?.codeName) {
      switch (searchParamsForUI?.helthProcedureData?.codeName) {
        case 'CPT4 Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CPTCode';
          break;
        case 'Revenue Codes':
          obj.RevenueCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'Revenue';
          obj.CodeDescription = 'RevenueCode';
          break;
        case 'CDT5 Dental Codes':
          obj.CDT = searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CDT';
          obj.CodeDescription = 'CDTCode';
          break;
        case 'DRG Codes':
          obj.DRGCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'DRGCode';
          obj.CodeDescription = 'DRGCode';
          break;
        case 'HCPCS Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        case 'CPT':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        default:
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = '';
          obj.CodeDescription = '';
          break;
      }
    }
    //obj.CodeOption =  "Revenue";
    //obj.RevenueCode = "0000";
    DATA.push(obj);
    return DATA;
  }
  const API_PAYLOAD = {
    pricecompareClaim: {
      searchParams: {
        providerType: providerType,
        procedureForData: searchParamsForUI?.procedureForData,
        helthProcedureData: searchParamsForUI?.helthProcedureData,
        locationData: searchParamsForUI?.locationData,
        providerByData: searchParamsForUI?.providerByData,
        networksData: searchParamsForUI?.networksData,
        typesOfSpecialtyData: searchParamsForUI?.typesOfSpecialtyData,
        maximumradius: searchProviderParams?.filters?.maximumradius,
        Gender: searchProviderParams?.filters?.Gender,
        AcceptingNewPatients: searchProviderParams?.AcceptingNewPatients,
        spokenlanguages: searchProviderParams?.filters?.spokenlanguages,
        specialities: searchProviderParams?.filters?.specialities,
        BilledAmt: searchParamsForUI?.billedamount,
      },
      comparison: {
        selectedCheckedItems: [data.ConnectorId],
        selectedCheckedRowData: [data],
      },
      apiData: apiDataGenerationForCompare({
        searchParamsForUI,
      }),
    },
  };

  const PriceCompareCoveredCost = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        APIEndpoints.getComparedRequestId() + '/storeasrecent/true',
        API_PAYLOAD,
      );
      const ClaimNumber =
        response.data.Response.PriceCompareClaimDTO[0].ClaimNumber;
      const DataItem = await axiosInstance.get(
        APIEndpoints.getCompareClaimDetails() + ClaimNumber,
      );
      const Covered = DataItem.data.Response.ReadClaimDTO;
      Covered['Serviceprovider'] = data.ConnectorId;
      Covered['Disclaimer'] =
        response.data.Response.PriceCompareClaimDTO[0].Disclaimer || null;
      setCoveredCostData(Covered);
      CoveredCostComparePriceArray?.CoveredCostComparePriceArray.push(Covered);
      setIsActiveCost(true);
      setLoading(false);
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };
  const handleClose = () => {
    setisOpenDisclaimerPopup(false);
  };
  const onToggleClickHandlerCost = () => {
    if (showCostBtnRef?.current < 10) {
      showCostBtnRef.current = 1;
      if (
        showCostClickCount >= showCostClickNumThreshold &&
        showCostClickTimestamp &&
        moment().unix() < parseInt(showCostClickTimestamp)
      ) {
        dispatch(setShowCostClickTimestamp());
        toast.error(
          <ToastMessage
            subTitle={`The maximum number of requests has been reached. You can submit the next request in 30 seconds.`}
            type="error"
          />,
        );
      } else {
        if (
          showCostClickTimestamp === null ||
          moment().unix() > showCostClickTimestamp
        ) {
          dispatch(setShowCostClickTimestamp());
          dispatch(resetShowCostClickCount());
        }
        dispatch(setShowCostClickCount());
        if (
          CoveredCostComparePriceArray?.CoveredCostComparePriceArray.length > 0
        ) {
          const showCover =
            CoveredCostComparePriceArray?.CoveredCostComparePriceArray.filter(
              (covered) => covered.Serviceprovider === data.ConnectorId,
            );
          console.log('showCover data', data);
          console.log('showCover', showCover[0]);
          if (showCover.length > 0) {
            setCoveredCostData(showCover[0]);
            setIsActiveCost(true);
          } else {
            PriceCompareCoveredCost();
          }
        } else {
          PriceCompareCoveredCost();
        }
      }
    }
  };
  useEffect(() => {
    setChecked(selectedCheckedItems.includes(data.ConnectorId));
  }, [selectedCheckedItems, data.ConnectorId]);
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
  const CoverageFormat = (coverage) => {
    if (coverage) {
      const data = coverage.toString().replace(/,/g, '');
      return formatter.format(data);
    } else {
      return formatter.format(coverage);
    }
  };
  return (
    <Fragment key={elemkey}>
      <div className="dashboard-navbar mb-4  container-offset" role="rowgroup">
        <Card className="provider-details-card ">
          <Row
            className={`profile-primary-info p-0 m-0 align-items-center justify-content-between ${
              isAccordion && !isActive && 'paddTop0'
            }`}
            role="row"
          >
            <Col lg={6} md={6} xs={11} className="p-0 m-0" role="cell">
              <div className="d-flex align-items-center no-flex-mobile">
                {isAccordion && (
                  <div className="mr-3 mb-4">
                    <CheckboxInput
                      inline
                      key={data.ConnectorId}
                      label=""
                      name={data.ConnectorId}
                      value={data.ConnectorId}
                      className="cursor-pointer"
                      id={data.ConnectorId}
                      onChange={(e) => {
                        onSelectRowHandler(e, data, data.ConnectorId);
                      }}
                      checked={checked}
                      isDisabled={
                        selectedCheckedItems.length >= 3 &&
                        !checked &&
                        !selectedCheckedItems.includes(data.ConnectorId)
                      }
                      ariaDisabled={
                        selectedCheckedItems.length >= 3 &&
                        !checked &&
                        !selectedCheckedItems.includes(data.ConnectorId)
                      }
                      ariaLabel={
                        selectedCheckedItems.length >= 3 &&
                        !checked &&
                        !selectedCheckedItems.includes(data.ConnectorId)
                          ? 'you have selected maximum 3 providers to compare'
                          : 'select the providers to compare'
                      }
                    />
                  </div>
                )}
                {Provider === 'facility' ? (
                  <FacilityIcon
                    className="image-color"
                    circleClassName="circle-color"
                  />
                ) : (
                  <>
                    {data?.Gender === 'Female' && (
                      <ProviderImageWomen
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                    {data?.Gender === 'Male' && (
                      <ProviderImageMen
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                    {(!data?.Gender || data?.Gender?.trim() === 'Unknown') && (
                      <ProviderImageUnknownGender
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                  </>
                )}
                <div className="ml-3 doctor-details-container">
                  {Provider === 'facility' ? (
                    <>
                      {data?.FacilityName?.length > 22 ? (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 200, hide: 450 }}
                          overlay={
                            <Popover>
                              <Popover.Content>
                                <div className="tooltip-header">
                                  {data?.FacilityName}
                                </div>
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <p
                            className="m-0 provider-name"
                            id={`provider-name-${data?.FacilityID}`}
                          >
                            <Link
                              to={`/admin/price-compare/facility-details/${data.FacilityID}/${data?.PostalCode}`}
                              state={{
                                memberType:
                                  searchParamsForUI?.procedureForData
                                    .memberType,
                                memberOid:
                                  searchParamsForUI?.procedureForData.value,
                              }}
                            >
                              {data?.FacilityName}
                            </Link>
                          </p>
                        </OverlayTrigger>
                      ) : (
                        <p
                          className="m-0 provider-name"
                          id={`provider-name-${data?.FacilityID}`}
                        >
                          <Link
                            to={`/admin/price-compare/facility-details/${data?.FacilityID}/${data?.PostalCode}`}
                            state={{
                              memberType:
                                searchParamsForUI?.procedureForData.memberType,
                              memberOid:
                                searchParamsForUI?.procedureForData.value,
                            }}
                          >
                            {data?.FacilityName}
                          </Link>
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      {formatDoctorName(
                        data?.DoctorTitle,
                        data?.LastName,
                        data?.FirstName,
                        data?.MiddleName,
                        data?.Suffix,
                      )?.length > 22 ? (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 200, hide: 450 }}
                          overlay={
                            <Popover>
                              <Popover.Content>
                                <div className="tooltip-header">
                                  {formatDoctorName(
                                    data?.DoctorTitle,
                                    data?.LastName,
                                    data?.FirstName,
                                    data?.MiddleName,
                                    data?.Suffix,
                                  )}
                                </div>
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <p
                            className="m-0 provider-name"
                            id={`provider-name-${data?.PhysicianID}`}
                          >
                            <Link
                              to={`/admin/price-compare/doctor-details/${data.PhysicianID}/${data?.Address?.PostalCode}`}
                              state={{
                                memberType:
                                  searchParamsForUI.procedureForData.memberType,
                                memberOid:
                                  searchParamsForUI.procedureForData.value,
                              }}
                            >
                              {formatDoctorName(
                                data?.DoctorTitle,
                                data?.LastName,
                                data?.FirstName,
                                data?.MiddleName,
                                data?.Suffix,
                              )}
                            </Link>
                          </p>
                        </OverlayTrigger>
                      ) : (
                        <p
                          className="m-0 provider-name"
                          id={`provider-name-${data?.PhysicianID}`}
                        >
                          <Link
                            to={`/admin/price-compare/doctor-details/${data.PhysicianID}/${data?.Address?.PostalCode}`}
                            state={{
                              memberType:
                                searchParamsForUI.procedureForData.memberType,
                              memberOid:
                                searchParamsForUI.procedureForData.value,
                            }}
                          >
                            {formatDoctorName(
                              data?.DoctorTitle,
                              data?.LastName,
                              data?.FirstName,
                              data?.MiddleName,
                              data?.Suffix,
                            )}
                          </Link>
                        </p>
                      )}
                    </>
                  )}
                  <p className="m-0 provider-spacality">
                    {/*#TODO: experience is not available in JV as per story 357  {18 years in Practice |}  */}
                    {data.Experiance && `${data.Experiance} in Practice |`}{' '}
                    {Provider === 'facility'
                      ? data?.FacilitySpeciality &&
                        data?.FacilitySpeciality.join(', ')
                      : data.Specialties && data.Specialties.join(', ')}
                  </p>
                  {data.ShowNetwork && (
                    <div className="section-networks network-hide-handler">
                      {Display_Network_Indicator_for_Price_Comparison_page ? (
                        data.InNetwork === true ? (
                          <InNetworkChip variant="success" />
                        ) : (
                          <InNetworkChip variant="danger" />
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                  {Provider === 'facility' ? (
                    <>
                      {data?.Distance > 0 && (
                        <p className="provider-get-driections d-block d-md-none mt-3 mt-md-0">
                          {/*<span>Get Directions</span>  */}

                          {
                            data?.Coordinateds && (
                              //<Link

                              //to={{

                              //pathname: `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${data.Address.Coordinateds}`

                              //}}

                              //target="_blank">

                              <span className="secondary-2">
                                {t(
                                  'member.price_comparison.result_card_distance',
                                )}
                              </span>
                            )

                            //</Link>
                          }

                          <br />

                          <span className="distance-count">
                            {data?.Distance &&
                              `${data?.Distance} mile${
                                Number(data?.Distance) > 1 ? 's' : ''
                              }`}
                          </span>
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      {data?.Address?.Distance > 0 && (
                        <p className="provider-get-driections d-block d-md-none mt-3 mt-md-0">
                          {/*<span>Get Directions</span>  */}
                          {
                            data?.Address?.Coordinateds && (
                              //<Link
                              //to={{
                              //pathname: `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${data.Address.Coordinateds}`
                              //}}
                              //target="_blank">
                              <span className="secondary-2">
                                {t(
                                  'member.price_comparison.result_card_distance',
                                )}
                              </span>
                            )
                            //</Link>
                          }
                          <br />
                          {/*<br /> */}
                          <span className="distance-count">
                            {data?.Address?.Distance &&
                              `${data?.Address?.Distance} mile${
                                Number(data?.Address?.Distance) > 1 ? 's' : ''
                              }`}
                          </span>
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Col>
            <Col
              md={isAccordion ? 4 : 4}
              xs={isAccordion ? 11 : 12}
              className="m-0 p-0 d-flex justify-content-end align-items-center"
              role="cell"
            >
              {data.ShowNetwork && (
                <div className="section-networks">
                  {Display_Network_Indicator_for_Price_Comparison_page ? (
                    data.InNetwork === true ? (
                      <InNetworkChip variant="success" />
                    ) : (
                      <InNetworkChip variant="danger" />
                    )
                  ) : (
                    ''
                  )}
                </div>
              )}
              {Provider === 'facility' ? (
                <>
                  {data?.Distance > 0 && (
                    <div className="provider-get-driections mt-3 mt-md-0 pr-3">
                      {data?.Coordinateds && (
                        <span className="secondary-2">
                          {t('member.price_comparison.result_card_distance')}
                        </span>
                      )}

                      <br />

                      <span className="distance-count">
                        {data?.Distance &&
                          `${data?.Distance} mile${
                            Number(data?.Distance) > 1 ? 's' : ''
                          }`}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {data?.Address?.Distance > 0 && (
                    <div className="provider-get-driections mt-3 mt-md-0 pr-3">
                      {data?.Address?.Coordinateds && (
                        <span className="secondary-2">
                          {t('member.price_comparison.result_card_distance')}
                        </span>
                      )}
                      <br />
                      <span className="distance-count">
                        {data?.Address?.Distance &&
                          `${data?.Address?.Distance} mile${
                            Number(data?.Address?.Distance) > 1 ? 's' : ''
                          }`}
                      </span>
                    </div>
                  )}
                </>
              )}
              {isAccordion && (
                <div
                  className="arrowContainer pr-2"
                  role="button"
                  tabIndex={0}
                  onClick={() => onToggleClickHandler()}
                  aria-expanded={isAccordion && isActive}
                  id={isAccordion && elemkey}
                  aria-controls={isAccordion && `section-${elemkey}`}
                >
                  <span className="sr-only">
                    Details of{' '}
                    {formatDoctorName(
                      data?.DoctorTitle,
                      data?.LastName,
                      data?.FirstName,
                      data?.MiddleName,
                      data?.Suffix,
                    )}{' '}
                    provider details
                  </span>
                  <span className="arrow">
                    {isActive ? (
                      <AccordionUpArrow className="acc-arrow" />
                    ) : (
                      <AccordionDownArrow className="acc-arrow" />
                    )}
                  </span>
                </div>
              )}
            </Col>
            <Col
              md={isAccordion ? 2 : 3}
              xs={isAccordion ? 11 : 12}
              className="py-2 pr-2 m-0 border-left d-flex align-items-stretch justify-content-center"
              role="cell"
            >
              <div className="cost-section pb-2 pt-1">
                <div
                  className={`d-none mt-1 patient_responsibility covered-cost ${
                    isActiveCost && 'd-block'
                  }`}
                >
                  <p className="title m-0 text-center">Covered Cost</p>
                  <p className="m-0 text-center value">
                    {' '}
                    {CoverageFormat(coveredCostData?.Covered)}
                  </p>
                </div>
                <div
                  className={`d-none mt-1 patient_responsibility covered-cost ${
                    isActiveCost && 'd-block'
                  }`}
                >
                  <p className="title m-0 text-center">
                    Patient Responsibility
                  </p>
                  <p className="m-0 text-center value">
                    {CoverageFormat(coveredCostData?.YouMayOwe)}
                  </p>
                </div>
                <div className={`mt-1  ${isActiveCost && 'd-none'}`}>
                  <GenericButton
                    className="ml-0 ml-md-1 mt-2 mt-md-0"
                    id="show-cost"
                    variant="secondary"
                    onClick={() => {
                      onToggleClickHandlerCost();
                    }}
                  >
                    {t('member.price_comparison.show_cost_button')}
                  </GenericButton>
                </div>
              </div>
            </Col>
          </Row>
          {loading ? (
            <SearchCoveredCard />
          ) : (
            <Row
              tabIndex={0}
              role={isAccordion && 'region'}
              className={`profile-seconday-info  ${
                isAccordion && 'accordion-content'
              } ${isActiveCost && 'accordion-content-open'}`}
              id={isAccordion && `section-cost${elemkey}`}
              aria-labelledby={isAccordion && elemkey}
            >
              <div
                role="row"
                className={`d-flex flex-adjuster w-100 ${
                  !isAccordion && !isActiveCost && 'padTop'
                } ${isAccordion && isActiveCost && 'padTop'} ${
                  isAccordion && 'row-item'
                }`}
              >
                <div role="cell" className="cost-details col pb-3 pb-md-0">
                  <div className="count-details-container">
                    <div className="left-container">
                      <div className="container-heading">
                        {t(
                          'member.price_comparison.finalResultTile.pricing_details',
                        )}
                        123
                      </div>
                      <div
                        className="count-details-main-wrapper"
                        role="section"
                      >
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.plan_pay',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.plan_pay',
                            )}
                            123
                          </span>
                          <span className="data-value">
                            {' '}
                            {CoverageFormat(coveredCostData?.PlanPay)}13
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.disallowed',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.disallowed',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(
                              coveredCostData?.Disallowed -
                                coveredCostData?.Copay -
                                (coveredCostData?.YouMayOwe -
                                  coveredCostData?.Copay -
                                  coveredCostData?.CoInsurance -
                                  coveredCostData?.Deductible),
                            )}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.copay',
                            )}
                          >
                            {t('member.price_comparison.finalResultTile.copay')}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(coveredCostData?.Copay)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.deductible',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.deductible',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(coveredCostData?.Deductible)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.co_insurance',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.co_insurance',
                            )}
                          </span>
                          <span className="data-value">
                            {' '}
                            {CoverageFormat(coveredCostData?.CoInsurance)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.other',
                            )}
                          >
                            {t('member.price_comparison.finalResultTile.other')}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(
                              coveredCostData?.YouMayOwe -
                                coveredCostData?.Copay -
                                coveredCostData?.CoInsurance -
                                coveredCostData?.Deductible,
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="right-container">
                      <div className="container-heading">
                        {t(
                          'member.price_comparison.finalResultTile.out_of_pocket',
                        )}
                      </div>
                      <div className="sr-only" id="accessibility-progressbar">
                        {data?.rightSideData?.OutOfPocket}% completed out of
                        100%
                      </div>
                      <div aria-describedby="accessibility-progressbar">
                        <ProgressBar
                          completed={findPercentage(
                            coveredCostData?.NetIndOOPMet,
                            coveredCostData?.NetIndOOPMax,
                          )}
                        />
                      </div>
                      <div
                        className="count-details-main-wrapper"
                        role="section"
                      >
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.applied',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.applied',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(coveredCostData?.NetIndOOPMet)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.remaining',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.remaining',
                            )}{' '}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(
                              coveredCostData?.NetIndOOPMax -
                                coveredCostData?.NetIndOOPMet >
                                0
                                ? coveredCostData?.NetIndOOPMax -
                                    coveredCostData?.NetIndOOPMet
                                : 0,
                            )}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.maximum',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.maximum',
                            )}
                          </span>
                          <span className="data-value">
                            {' '}
                            {CoverageFormat(coveredCostData?.NetIndOOPMax)}
                          </span>
                        </div>
                      </div>
                    </div>
                    {coveredCostData?.Disclaimer && (
                      <div className="warning-parent mt-4">
                        <div className="disclaimer-svg">
                          <ConfigurationSVG.WarningSVG />
                        </div>
                        <div className="warning-content">
                          <span className="content-bold">Disclaimer: {''}</span>
                          <span className="disclaimer-text">
                            {' '}
                            {coveredCostData.Disclaimer}
                          </span>
                          {coveredCostData.Disclaimer.length > 80 && (
                            <span className="button-position">
                              <GenericButton
                                variant="link"
                                className="viewmore-btn"
                                onClick={() => {
                                  setisOpenDisclaimerPopup(
                                    !isOpenDisclaimerPopup,
                                  );
                                }}
                              >
                                View More
                              </GenericButton>
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Row>
          )}
          <Row
            tabIndex={0}
            role={isAccordion && 'region'}
            className={`profile-seconday-info  ${
              isAccordion && 'accordion-content'
            } ${isActive && 'accordion-content-open'}`}
            id={isAccordion && `section-${elemkey}`}
            aria-labelledby={isAccordion && elemkey}
          >
            <div
              role="row"
              className={`d-flex flex-adjuster w-100 ${
                !isAccordion && !isActive && 'padTop'
              } ${isAccordion && isActive && 'padTop'} ${
                isAccordion && 'row-item'
              }`}
            >
              <div
                role="cell"
                className="col-xs-12 border-right-info col-md-4 pb-3 pb-md-0"
              >
                {Provider === 'facility' ? (
                  <div className="provider-location-info">
                    <p className="provider-location-data">
                      {/*{!data?.Gender || data.Gender === 'Unknown'

      ? 'N/A (Gender)'

      : `${data?.Gender} (Gender)`}{' '}

    {data?.Experiance

      ? ` | ${data?.Experiance} years in Practice`

      : ''} */}
                    </p>

                    <p className="provider-location-data">
                      {data?.Address1 && `${data?.Address1}, `}

                      {data?.Address2 && `${data?.Address2}, `}

                      {data?.Address3 && `${data?.Address3}, `}

                      {data?.City && `${data?.City}, `}

                      {data?.County && `${data?.County}, `}

                      {data?.StateProv && `${data?.StateProv}, `}

                      {data?.PostalCode && `${data?.PostalCode}`}
                    </p>

                    <p className="provider-contact-data">
                      {data.Phone ? data.Phone : noDataMessage}
                    </p>
                  </div>
                ) : (
                  <div className="provider-location-info">
                    <p className="provider-location-data">
                      {!data?.Gender || data.Gender === 'Unknown'
                        ? 'N/A (Gender)'
                        : `${data?.Gender} (Gender)`}{' '}
                      {data?.Experiance
                        ? ` | ${data?.Experiance} years in Practice`
                        : ''}
                    </p>
                    <p className="provider-location-data">
                      {data?.Address?.AddressLine1 &&
                        `${data?.Address?.AddressLine1}, `}
                      {data?.Address?.AddressLine2 &&
                        `${data?.Address?.AddressLine2}, `}
                      {data?.Address?.AddressLine3 &&
                        `${data?.Address?.AddressLine3}, `}
                      {data?.Address?.City && `${data?.Address?.City}, `}
                      {data?.Address?.County && `${data?.Address?.County}, `}
                      {data?.Address?.State && `${data?.Address?.State}, `}
                      {data?.Address?.PostalCode &&
                        `${data?.Address?.PostalCode}`}
                    </p>
                    <p className="provider-contact-data">
                      {data.Phone ? data.Phone : noDataMessage}
                    </p>
                  </div>
                )}
              </div>
              {Provider !== 'facility' && (
                <div
                  role="cell"
                  className="col-md-3 col-xs-12 border-right-info pb-3 pb-md-0"
                >
                  <div className="section-networks">
                    <div className="mt-3">
                      {data.AcceptingNewPatients === true ? (
                        <AcceptingNewPatientsChip variant="success" />
                      ) : (
                        <AcceptingNewPatientsChip variant="danger" />
                      )}
                      <div className="provider-languages-info mt-3">
                        <p className="provider-language-heading">
                          {t('find_provider.language_spoken')}
                        </p>
                        <p className="provider-languages-data">
                          {data.SpokenLanguages
                            ? data.SpokenLanguages.join(', ')
                            : noDataMessage}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div role="cell" className="col-xs-12 col-md-5 mt-3 mt-md-0">
                {data.InNetwork === true &&
                  Display_Network_For_PriceComparison_Admin && (
                    <div>
                      <p className="provider-contact-heading m-0 p-0 mt-2">
                        {Value_Network_For_PriceComparison_Admin === 'tier' &&
                        uniqueTier?.length > 0
                          ? t(
                              'member.price_comparison.provider_container.networks_dropdown_labelTier',
                            )
                          : Value_Network_For_PriceComparison_Admin ===
                              'network' && inNetworkList?.length > 0
                          ? t(
                              'member.price_comparison.provider_container.networks_dropdown_label',
                            )
                          : ''}
                      </p>
                      <div className="networks-list">
                        {Value_Network_For_PriceComparison_Admin ===
                          'network' && (
                          <>
                            {inNetworkList?.length > 0 &&
                              data.InNetwork === true && (
                                <>
                                  {inNetworkList
                                    ?.slice(0, 2)
                                    .map((networkName, index) => {
                                      return (
                                        <React.Fragment
                                          key={`${networkName} ${index}`}
                                        >
                                          {serachNetworksFor?.value ===
                                          networkName ? (
                                            <span className="d-flex align-items-start">
                                              <span className="network-success">
                                                <SuccessCircle className="success-circle" />
                                              </span>
                                              <span className="ml-2">
                                                <span className="provider-contact-heading">
                                                  {networkName}
                                                  {inNetworkList?.indexOf(
                                                    networkName,
                                                  ) !==
                                                  inNetworkList?.length - 1
                                                    ? ','
                                                    : ''}
                                                </span>
                                              </span>
                                            </span>
                                          ) : (
                                            <span className="provider-contact-data mt-1 mb-1">
                                              {networkName}
                                              {inNetworkList?.indexOf(
                                                networkName,
                                              ) !==
                                              inNetworkList?.length - 1
                                                ? ','
                                                : ''}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}

                                  {inNetworkList?.length > 2 &&
                                    (Provider === 'facility' ? (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/admin/price-compare/facility-details/${data?.FacilityID}/${data?.PostalCode}`}
                                          state={{
                                            memberType:
                                              searchParamsForUI.procedureForData
                                                .memberType,
                                            memberOid:
                                              searchParamsForUI.procedureForData
                                                .value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{inNetworkList?.length - 2}{' '}
                                            {t('find_provider.networks')}
                                          </span>
                                        </Link>
                                      </span>
                                    ) : (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/admin/price-compare/doctor-details/${data?.PhysicianID}/${data?.Address?.PostalCode}`}
                                          state={{
                                            memberType:
                                              searchParamsForUI.procedureForData
                                                .memberType,
                                            memberOid:
                                              searchParamsForUI.procedureForData
                                                .value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{inNetworkList?.length - 2}{' '}
                                            {t('find_provider.networks')}
                                          </span>
                                        </Link>
                                      </span>
                                    ))}
                                </>
                              )}
                          </>
                        )}
                        {Value_Network_For_PriceComparison_Admin === 'tier' && (
                          <>
                            {uniqueTier?.length > 0 &&
                              data.InNetwork === true && (
                                <>
                                  {uniqueTier
                                    ?.slice(0, 2)
                                    .map((networkName, index) => {
                                      return (
                                        <React.Fragment
                                          key={`${networkName} ${index}`}
                                        >
                                          {serachNetworksFor?.label ===
                                          networkName ? (
                                            <span className="d-flex align-items-start">
                                              <span className="network-success">
                                                <SuccessCircle className="success-circle" />
                                              </span>
                                              <span className="ml-2">
                                                <span className="provider-contact-heading">
                                                  {networkName}
                                                </span>
                                              </span>
                                            </span>
                                          ) : (
                                            <span className="provider-contact-data mt-1 mb-1">
                                              {networkName}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  {uniqueTier?.length > 2 &&
                                    (Provider === 'facility' ? (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/admin/price-compare/facility-details/${data?.FacilityID}/${data?.PostalCode}`}
                                          state={{
                                            memberType:
                                              searchParamsForUI
                                                ?.procedureForData.memberType,
                                            memberOid:
                                              searchParamsForUI
                                                ?.procedureForData.value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{uniqueTier?.length - 2}{' '}
                                            {Value_Network_For_PriceComparison_Admin ===
                                            'tier'
                                              ? t(
                                                  'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                                )
                                              : t(
                                                  'member.price_comparison.provider_container.networks_dropdown_label',
                                                )}
                                          </span>
                                        </Link>
                                      </span>
                                    ) : (
                                      <span className="secondary-2 provider-contact-data">
                                        <Link
                                          to={`/admin/price-compare/doctor-details/${data?.PhysicianID}/${data?.Address?.PostalCode}`}
                                          state={{
                                            memberType:
                                              searchParamsForUI.procedureForData
                                                .memberType,
                                            memberOid:
                                              searchParamsForUI.procedureForData
                                                .value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{uniqueTier?.length - 2}{' '}
                                            {Value_Network_For_PriceComparison_Admin ===
                                            'tier'
                                              ? t(
                                                  'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                                )
                                              : t(
                                                  'member.price_comparison.provider_container.networks_dropdown_label',
                                                )}
                                          </span>
                                        </Link>
                                      </span>
                                    ))}
                                </>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </Row>
        </Card>
      </div>
      {isOpenDisclaimerPopup && (
        <div>
          <Modal
            show={isOpenDisclaimerPopup}
            onHide={handleClose}
            centered
            className={`Right-Model member generic-model`}
          >
            <Modal.Header closeButton className="plandocument-header">
              <Container className="px-0">
                <Row className="align-items-center p-0 m-0">
                  <Col className="px-0">
                    <Modal.Title>Disclaimer</Modal.Title>
                  </Col>
                </Row>
              </Container>
            </Modal.Header>

            <Modal.Body className="disclaimer-body">
              <Container className="px-0 custom-scroller modal-content-container pl-4 disclaimer-modal-container">
                <div className="warning-content">
                  {coveredCostData.Disclaimer}
                </div>
              </Container>
            </Modal.Body>

            <Modal.Footer className="admin bg-white footer-class disclaimer-footer-btn">
              <div className="model-footer-btn txt-right p-0 m-0 border-0">
                {/*<GenericButton
                  className="p-0 m-0"
                  onClick={() => handleClose()}
                >
                  {t('label_cancel')}
                </GenericButton> */}
                <button onClick={() => handleClose()} className="close-btn">
                  Close
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </Fragment>
  );
};

export default ResultCard;
